export default "__VITE_PUBLIC_ASSET__d111dd1f__"